var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"log"},[_c('div',{staticClass:"mb-10 font-semibold"},[_vm._v("Google近一小时订单通知：")]),_c('ad-table-page',{staticClass:"h-full",attrs:{"showForm":false,"tableConfig":_vm.tableConfig},model:{value:(_vm.formData),callback:function ($$v) {_vm.formData=$$v},expression:"formData"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }